import React from 'react'

// core components
import GridContainer from 'components/Grid/GridContainer.jsx'
import ItemGrid from 'components/Grid/ItemGrid.jsx'
import RegularCard from 'components/Cards/RegularCard.jsx'

import FormCliente from './FormCliente'

class NuovoCliente extends React.Component {

  handleCreated = history => event => {
    history.push('/clienti')
  }

  render() {
    return (
      <RegularCard
        cardTitle={
          <div>
            <h3 style={{ display: 'inline-block' }}>Nuovo cliente</h3>
          </div>
        }
        content={
          <GridContainer justify="space-around" alignItems="baseline" direction="row">
            <ItemGrid xs={11} md={5} lg={4}>
              <FormCliente onSaved={this.handleCreated(this.props.history)} />
            </ItemGrid>
            <ItemGrid xs={11} md={5} lg={4}></ItemGrid>
          </GridContainer>
        }
      />
    )
  }
}

export default NuovoCliente



// WEBPACK FOOTER //
// ./src/views/App/Clienti/NuovoCliente.jsx